import {isAnalytixLive} from './premise';

export const getFaviconPath = () => {
  /*
   * Might vary on premise
   */
  const basePath: string = '/static/assets/images/';

  if (isAnalytixLive()) {
    return basePath + 'analytixlive/favicon.png'
  }
  return basePath + 'favicon-32x32.png';
}
